import { Injectable, InjectionToken, Injector } from '@angular/core';
import { FiNotificationService } from '../notification.service';

export const CountdownNotificationRef = new InjectionToken('CountdownNotificationRef');

@Injectable()
export class FiCountdownNotificationService {
    constructor(
        private notificationService: FiNotificationService,
        private injector: Injector,
    ) {}

    StartCountDown(params: ICountdownNotificationParams, factory, injector?: Injector) {
        const contDownRef: ICountdownNotificationRefData = {
            countDownTitle: params.countDownTitle,
            countDownText: params.countDownText,
            countDownTime: params.countDownTime,
            cssClass: params.cssClass,
            params: params,
        };

        const countDownInjector = Injector.create({
            providers: [
                {
                    provide: CountdownNotificationRef,
                    useValue: contDownRef,
                },
            ],
            parent: injector || this.injector,
        });

        return this.notificationService.AddNotification(factory, countDownInjector);
    }
}
